import React, { useState, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { FaEdit } from "react-icons/fa";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { useNavigate } from "react-router-dom";
import AllProductCarsDetails from './AllProductCars';
import { Dropdown } from "primereact/dropdown"; // ✅ make sure this is imported
import CarsDetails from "./SingleProductCars"
import SingleProductCarsEDIT from "../ProductCars/SingleProductCarsEDIT";

function TabViewCars() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showEditDialog, setShowEditDialog] = useState(false);
  const [showAddDialog, setShowAddDialog] = useState(false);

  const [productID, setProductID] = useState("");
  const [productName, setProductName] = useState("");
  const [sellingPrice, setSellingPrice] = useState("");
  const [genericName, setGenericName] = useState("");
  const [numberOfSeats, setNumberOfSeats] = useState("");
  const [description, setDescription] = useState("");
  const [type, setType] = useState("");
  const [color, setColor] = useState("");
  const [deliveryCondition, setDeliveryCondition] = useState("");
  const [seatbeltIncluded, setSeatbeltIncluded] = useState(false);
  const [otherPowerFeatures, setOtherPowerFeatures] = useState("");
  const [notCoveredInWarranty, setNotCoveredInWarranty] = useState("");
  const [otherConvenienceFeatures, setOtherConvenienceFeatures] = useState("");
  const [coveredInWarranty, setCoveredInWarranty] = useState("");
  const [mpThreePlayerSupported, setMpThreePlayerSupported] = useState(false);
  const [maximumUserWeight, setMaximumUserWeight] = useState("");
  const [stockAvailability, setStockAvailability] = useState(true);
  const [categoryID, setCategoryID] = useState("");
  const [modelNumber, setModelNumber] = useState("");
  const [ageGroup, setAgeGroup] = useState("");
  const [brand, setBrand] = useState("");
  const [price, setPrice] = useState("");
  const [netQuantity, setNetQuantity] = useState("");
  const [warrenty, setWarrenty] = useState("");
  const [speed, setSpeed] = useState("");
  const [dimentions, setDimentions] = useState("");
  const [countryOfOrigin, setCountryOfOrigin] = useState("");
  const [lights, setLights] = useState("");
  const [horn, setHorn] = useState("");
  const [weight, setWeight] = useState("");
  const [manufacturer, setManufacturer] = useState("");
  const [batteryIncluded, setBatteryIncluded] = useState(false);
  const [noOfBatteries, setNoOfBatteries] = useState("");
  const [batteryOperated, setBatteryOperated] = useState(false);
  const [batteryType, setBatteryType] = useState("");
  const [parentalRemote, setParentalRemote] = useState(false);
  const [keyStart, setKeyStart] = useState(false);
  const [rechargeable, setRechargeable] = useState(false);
  const [quantity, setQuantity] = useState("");
  // const [visibleDialog, setVisibleDialog] = useState(false);
  // const [selectedProductID, setSelectedProductID] = useState(null);

  // const [selectedProduct, setSelectedProduct] = useState(null);

  // const handleEditRowClick = (rowData) => {
  //   setSelectedProduct(rowData);
  //   setVisibleDialog(true);
  // };

  const fetchAllCars = async () => {
    setLoading(true);
    try {
      const response = await fetch("/allCars");
      const result = await response.json();
      setProducts(result);
    } catch (err) {
      console.error("Error fetching data:", err);
      setProducts([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllCars();
  }, []);

  const clearVariables = () => {
    setProductID("");
    setCategoryID("");
    setProductName("");
    setDescription("");
    setPrice("");
    // setSellingPrice(rowData.sellingPrice);
    setGenericName("");
    setBrand("");
    setModelNumber("");
    setType("");
    setAgeGroup("");
    setMaximumUserWeight("");
    setNetQuantity("");
    setSpeed("");
    setDeliveryCondition("");
    setNumberOfSeats("");
    setBatteryOperated("");
    setNoOfBatteries("");
    setBatteryIncluded("");
    setRechargeable("");
    setBatteryType("");
    setOtherPowerFeatures("");
    setKeyStart("");
    setSeatbeltIncluded("");
    setMpThreePlayerSupported("");
    setParentalRemote("");
    setLights("");
    setHorn("");
    setOtherConvenienceFeatures("");
    setDimentions("");
    setWeight("");
    setCountryOfOrigin("");
    setManufacturer("");
    setWarrenty("");
    setCoveredInWarranty("");
    setNotCoveredInWarranty("");
    setColor("");
    setQuantity("");
    setStockAvailability("");
    fetchAllCars();
    //  fetchFileByCaseID();
  };

  const storeTbleDataInVariables = (rowData) => {
    setProductID(rowData.productID);
    setCategoryID(rowData.categoryID);
    setProductName(rowData.productName);
    setDescription(rowData.description);
    setPrice(rowData.price);
    // setSellingPrice(rowData.sellingPrice);
    setGenericName(rowData.genericName);
    setBrand(rowData.brand);
    setModelNumber(rowData.modelNumber);
    setType(rowData.type);
    setAgeGroup(rowData.ageGroup);
    setMaximumUserWeight(rowData.maximumUserWeight);
    setNetQuantity(rowData.netQuantity);
    setSpeed(rowData.speed);
    setDeliveryCondition(rowData.deliveryCondition);
    setNumberOfSeats(rowData.numberOfSeats);
    setBatteryOperated(rowData.batteryOperated);
    setNoOfBatteries(rowData.noOfBatteries);
    setBatteryIncluded(rowData.batteryIncluded);

    setRechargeable(rowData.rechargeable);
    setBatteryType(rowData.batteryType);
    setOtherPowerFeatures(rowData.otherPowerFeatures);
    setKeyStart(rowData.keyStart);
    setSeatbeltIncluded(rowData.seatbeltIncluded);
    setMpThreePlayerSupported(rowData.mpThreePlayerSupported);
    setParentalRemote(rowData.parentalRemote);
    setLights(rowData.lights);
    setHorn(rowData.horn);
    setOtherConvenienceFeatures(rowData.otherConvenienceFeatures);
    setDimentions(rowData.dimentions);
    setWeight(rowData.weight);
    setCountryOfOrigin(rowData.countryOfOrigin);
    setManufacturer(rowData.manufacturer);
    setWarrenty(rowData.warrenty);
    setCoveredInWarranty(rowData.coveredInWarranty);
    setNotCoveredInWarranty(rowData.notCoveredInWarranty);
    setColor(rowData.color);
    setQuantity(rowData.quantity);
    setStockAvailability(rowData.stockAvailability);
    fetchAllCars();
    //  fetchFileByCaseID();
  };

  const handleSubmitAddCars = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("/insertOrUpdateCars", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          incidentUpdateID: null,
          insertOrUpdate: "InsertInBothTables",
          productID: productID,
          categoryID: parseInt(categoryID),
          productName: productName,
          description: description,
          price: parseFloat(price),
          sellingPrice: parseFloat(sellingPrice),
          genericName: genericName,
          brand: brand,
          modelNumber: modelNumber,
          type: type,
          ageGroup: ageGroup,
          maximumUserWeight: maximumUserWeight,
          netQuantity: parseInt(netQuantity),
          speed: speed,
          deliveryCondition: deliveryCondition,
          numberOfSeats: parseInt(numberOfSeats),
          batteryOperated: true,
          noOfBatteries: parseInt(noOfBatteries),
          batteryIncluded: true,
          rechargeable: true,
          batteryType: batteryType,
          otherPowerFeatures: otherPowerFeatures,
          keyStart: keyStart,
          seatbeltIncluded: true,
          mpThreePlayerSupported: true,
          parentalRemote: true,
          lights: true,
          horn: true,
          otherConvenienceFeatures: otherConvenienceFeatures,
          dimentions: dimentions,
          weight: weight,
          countryOfOrigin: countryOfOrigin,
          manufacturer: manufacturer,
          warrenty: warrenty,
          coveredInWarranty: coveredInWarranty,
          notCoveredInWarranty: notCoveredInWarranty,
          color: color,
          quantity: parseInt(quantity),
          stockAvailability: stockAvailability,
        }),
      });
      const data = await response.text();
      console.log("Success:", data);
      if (response.ok) {
        alert("Car Added successfully");
        setShowAddDialog(false);
        fetchAllCars();
        clearVariables();
      } else if (!response.ok) {
        const errorText = await response.text();
        console.error("Bad Request:", errorText);
        alert("Failed to Add cars");
        throw new Error("Request failed");
      }
    } catch (err) {
      console.error("API call error:", err);
    }
  };

  const handleSubmitUpdate = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("/updateCars", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          incidentUpdateID: null,
          insertOrUpdate: "UpdatingCarsAndInventory",
          productID: productID,
          categoryID: parseInt(categoryID),
          productName: productName,
          description: description,
          price: parseFloat(price),
          sellingPrice: parseFloat(sellingPrice),
          genericName: genericName,
          brand: brand,
          modelNumber: modelNumber,
          type: type,
          ageGroup: ageGroup,
          maximumUserWeight: maximumUserWeight,
          netQuantity: parseInt(netQuantity),
          speed: speed,
          deliveryCondition: deliveryCondition,
          numberOfSeats: parseInt(numberOfSeats),
          batteryOperated: true,
          noOfBatteries: parseInt(noOfBatteries),
          batteryIncluded: true,
          rechargeable: true,
          batteryType: batteryType,
          otherPowerFeatures: otherPowerFeatures,
          keyStart: keyStart,
          seatbeltIncluded: true,
          mpThreePlayerSupported: true,
          parentalRemote: true,
          lights: true,
          horn: true,
          otherConvenienceFeatures: otherConvenienceFeatures,
          dimentions: dimentions,
          weight: weight,
          countryOfOrigin: countryOfOrigin,
          manufacturer: manufacturer,
          warrenty: warrenty,
          coveredInWarranty: coveredInWarranty,
          notCoveredInWarranty: notCoveredInWarranty,
          color: color,
          quantity: parseInt(quantity),
          stockAvailability: stockAvailability,
        }),
      });
      const data = await response.text();
      console.log("Success:", data);
      if (response.ok) {
        alert("Car updated successfully");
        setShowEditDialog(false);
        clearVariables();
        fetchAllCars();
      } else if (!response.ok) {
        const errorText = await response.text();
        console.error("Bad Request:", errorText);
        alert("Failed to update car");
        throw new Error("Request failed");
      }
    } catch (err) {
      console.error("API call error:", err);
    }
  };

  const handleEditRowClickm = (rowData) => {
    return (
      <>
        <Button
          onClick={() => {
            storeTbleDataInVariables(rowData);
            setShowEditDialog(true);
          }}
          text
        >
          <FaEdit />
        </Button>
      </>
    );
  };

  const navigate = useNavigate();
  const yesNoOptions = [
    { label: "Yes", value: "Yes" },
    { label: "No", value: "No" },
  ];

 const [visibleDialog, setVisibleDialog] = useState(false);
 const [dialogMode, setDialogMode] = useState("view"); // 'view' or 'edit'
 const [selectedProductID, setSelectedProductID] = useState(null);

 const handleViewClick = (productId) => {
   sessionStorage.setItem("productId", productId);
   setSelectedProductID(productId);
   setDialogMode("view");
   setVisibleDialog(true);
 };

 const handleEditRowClick = (rowData) => {
   sessionStorage.setItem("productId", rowData.productID);
   setSelectedProductID(rowData.productID);
   setDialogMode("edit");
   setVisibleDialog(true);
 };




  return (
    <div>
      {/* <Dialog
        header="Product Details"
        visible={visibleDialog}
        onHide={() => setVisibleDialog(false)}
        dismissableMask
        modal
        className="custom-dialog"
        style={{ width: "95vw", maxWidth: "900px" }} 
      >
        <div
          style={{
            maxHeight: "80vh",
            
          }}
        >
          
          <CarsDetails />
        </div>
      </Dialog>

      <Dialog
        header="Product Details"
        visible={visibleDialog}
        onHide={() => setVisibleDialog(false)}
        dismissableMask
        modal
        className="custom-dialog"
        style={{ width: "95vw", maxWidth: "900px" }} 
      >
        <div
          style={{
            maxHeight: "80vh",
            
          }}
        >
          <SingleProductCarsEDIT />
        </div>
      </Dialog> */}
       <Dialog
        header="Product Details"
        visible={visibleDialog}
        onHide={() => setVisibleDialog(false)}
        dismissableMask
        modal
        className="custom-dialog"
        style={{ width: "95vw", maxWidth: "900px" }}
      >
        <div style={{ maxHeight: "80vh" }}>
          {dialogMode === "view" ? <CarsDetails /> : <SingleProductCarsEDIT />}
        </div>
      </Dialog>

      <Dialog
        className="custom-dialog"
        visible={showAddDialog}
        onHide={() => {
          setShowAddDialog(false);
          clearVariables();
        }}
        header="Add Car Products Details"
      >
        <div className="flex gap-3">
          <div className="flex flex-column">
            <label htmlFor="productID">
              <b>Product</b>
            </label>

            <InputText
              id="productID"
              type="text"
              value={productID}
              onChange={(e) => setProductID(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label htmlFor="productName">
              <b>Product Name</b>
            </label>
            <InputText
              id="productName"
              type="text"
              value={productName}
              onChange={(e) => setProductName(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label>
              <b>Description</b>
            </label>
            <InputText
              type="text"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>
        </div>

        <div className="flex gap-3">
          <div className="flex flex-column">
            <label>
              <b>Price</b>
            </label>
            <InputText
              type="text"
              value={price}
              onChange={(e) => setPrice(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label>
              <b>Selling Price</b>
            </label>
            <InputText
              type="text"
              value={sellingPrice}
              onChange={(e) => setSellingPrice(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label>
              <b>Generic Name</b>
            </label>
            <InputText
              type="text"
              value={genericName}
              onChange={(e) => setGenericName(e.target.value)}
            />
          </div>
        </div>

        <div className="flex gap-3">
          <div className="flex flex-column">
            <label>
              <b>Brand</b>
            </label>
            <InputText
              type="text"
              value={brand}
              onChange={(e) => setBrand(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label>
              <b>Model Number</b>
            </label>
            <InputText
              type="text"
              value={modelNumber}
              onChange={(e) => setModelNumber(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label>
              <b>Type</b>
            </label>
            <InputText
              type="text"
              value={type}
              onChange={(e) => setType(e.target.value)}
            />
          </div>
        </div>

        <div className="flex gap-3">
          <div className="flex flex-column">
            <label>
              <b>Age</b>
            </label>
            <InputText
              type="text"
              value={ageGroup}
              onChange={(e) => setAgeGroup(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label>
              <b>Maximum Weight</b>
            </label>
            <InputText
              type="text"
              value={maximumUserWeight}
              onChange={(e) => setMaximumUserWeight(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label>
              <b>Speed</b>
            </label>
            <InputText
              type="text"
              value={speed}
              onChange={(e) => setSpeed(e.target.value)}
            />
          </div>
        </div>

        <div className="flex gap-3">
          <div className="flex flex-column">
            <label>
              <b>Delivery Condition</b>
            </label>
            <InputText
              type="text"
              value={deliveryCondition}
              onChange={(e) => setDeliveryCondition(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label>
              <b>No Of Seats</b>
            </label>
            <InputText
              type="text"
              value={numberOfSeats}
              onChange={(e) => setNumberOfSeats(e.target.value)}
            />
          </div>
          {/* <div className="flex flex-column">
            <label>Battery Operated</label>
            <Dropdown
              // type="text"
              value={batteryOperated}
              options={yesNoOptions}
              onChange={(e) => setBatteryOperated(e.target.value)}
              className="w-full"
            />
          </div> */}
          <div className="flex flex-column w-full">
            <label>
              <b>Battery Operated</b>
            </label>
            <Dropdown
              value={batteryOperated}
              options={yesNoOptions}
              onChange={(e) => setBatteryOperated(e.target.value)}
              placeholder="Select"
              className="w-full"
            />
          </div>
        </div>

        <div className="flex gap-3">
          <div className="flex flex-column">
            <label>
              <b>No Of Batteries</b>
            </label>
            <InputText
              type="text"
              value={noOfBatteries}
              onChange={(e) => setNoOfBatteries(e.target.value)}
            />
          </div>
          {/* <div className="flex flex-column">
            <label>Rechargeable</label>
            <InputText
              type="text"
              value={rechargeable}
              onChange={(e) => setRechargeable(e.target.value)}
            />
          </div> */}
          <div className="flex flex-column w-full">
            <label>
              <b>Rechargeable</b>
            </label>
            <Dropdown
              value={rechargeable}
              options={yesNoOptions}
              onChange={(e) => setRechargeable(e.target.value)}
              placeholder="Select"
              className="w-full"
            />
          </div>
          <div className="flex flex-column">
            <label>
              <b>Battery Type</b>
            </label>
            <InputText
              type="text"
              value={batteryType}
              onChange={(e) => setBatteryType(e.target.value)}
            />
          </div>
        </div>

        <div className="flex gap-3">
          <div className="flex flex-column">
            <label>
              <b>Other Power Details</b>
            </label>
            <InputText
              type="text"
              value={otherPowerFeatures}
              onChange={(e) => setOtherPowerFeatures(e.target.value)}
            />
          </div>
          {/* <div className="flex flex-column">
            <label>Key Start</label>
            <InputText
              type="text"
              value={keyStart}
              onChange={(e) => setKeyStart(e.target.value)}
            />
          </div> */}
          <div className="flex flex-column w-full">
            <label>
              <b>Key Start</b>
            </label>
            <Dropdown
              value={keyStart}
              options={yesNoOptions}
              onChange={(e) => setKeyStart(e.target.value)}
              placeholder="Select"
              className="w-full"
            />
          </div>
          {/* <div className="flex flex-column">
            <label>Parental Remote</label>
            <InputText
              type="text"
              value={parentalRemote}
              onChange={(e) => setParentalRemote(e.target.value)}
            />
          </div> */}
          <div className="flex flex-column w-full">
            <label>
              <b>Parental Remote</b>
            </label>
            <Dropdown
              value={parentalRemote}
              options={yesNoOptions}
              onChange={(e) => setParentalRemote(e.target.value)}
              placeholder="Select"
              className="w-full"
            />
          </div>
        </div>

        <div className="flex gap-3">
          {/* <div className="flex flex-column">
            <label>Light</label>
            <InputText
              type="text"
              value={lights}
              onChange={(e) => setLights(e.target.value)}
            />
          </div> */}
          <div className="flex flex-column w-full">
            <label>
              <b>Light</b>
            </label>
            <Dropdown
              value={lights}
              options={yesNoOptions}
              onChange={(e) => setLights(e.target.value)}
              placeholder="Select"
              className="w-full"
            />
          </div>
          {/* <div className="flex flex-column">
            <label>Horn</label>
            <InputText
              type="text"
              value={horn}
              onChange={(e) => setHorn(e.target.value)}
            />
          </div> */}
          <div className="flex flex-column w-full">
            <label>
              <b>Horn</b>
            </label>
            <Dropdown
              value={horn}
              options={yesNoOptions}
              onChange={(e) => setHorn(e.target.value)}
              placeholder="Select"
              className="w-full"
            />
          </div>
          <div className="flex flex-column">
            <label>
              <b>Dimentions</b>
            </label>
            <InputText
              type="text"
              value={dimentions}
              onChange={(e) => setDimentions(e.target.value)}
            />
          </div>
        </div>

        <div className="flex gap-3">
          <div className="flex flex-column">
            <label>
              <b>Country</b>
            </label>
            <InputText
              type="text"
              value={countryOfOrigin}
              onChange={(e) => setCountryOfOrigin(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label>
              <b>Manufacter</b>
            </label>
            <InputText
              type="text"
              value={manufacturer}
              onChange={(e) => setManufacturer(e.target.value)}
            />
          </div>
          {/* <div className="flex flex-column">
            <label>Warrenty</label>
            <InputText
              type="text"
              value={warrenty}
              onChange={(e) => setWarrenty(e.target.value)}
            />
          </div> */}
          <div className="flex flex-column w-full">
            <label>
              <b>Warrenty</b>
            </label>
            <Dropdown
              value={warrenty}
              options={yesNoOptions}
              onChange={(e) => setWarrenty(e.target.value)}
              placeholder="Select"
              className="w-full"
            />
          </div>
        </div>

        <div className="flex gap-3">
          <div className="flex flex-column">
            <label>
              <b>Coverd In Warrenty</b>
            </label>
            <InputText
              type="text"
              value={coveredInWarranty}
              onChange={(e) => setCoveredInWarranty(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label>
              <b>Not Coverd In Warrenty</b>
            </label>
            <InputText
              type="text"
              value={notCoveredInWarranty}
              onChange={(e) => setNotCoveredInWarranty(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label>
              <b>Color</b>
            </label>
            <InputText
              type="text"
              value={color}
              onChange={(e) => setColor(e.target.value)}
            />
          </div>
        </div>

        <div className="flex gap-3">
          {/* <div className="flex flex-column">
            <label>Stock Availability</label>
            <InputText
              type="text"
              value={stockAvailability}
              onChange={(e) => setStockAvailability(e.target.value)}
            />
          </div> */}

          <div className="flex flex-column w-full">
            <label>
              <b>Stock Availability</b>
            </label>
            <Dropdown
              value={stockAvailability}
              options={yesNoOptions}
              onChange={(e) => setStockAvailability(e.target.value)}
              placeholder="Select"
              // className="w-full"
            />
          </div>

          <div className="flex flex-column">
            <label>
              <b>Quantity</b>
            </label>
            <InputText
              type="text"
              value={quantity}
              onChange={(e) => setQuantity(e.target.value)}
            />
          </div>
        </div>

        <Button
          className="justify-content-center m-2"
          type="submit"
          onClick={(e) => handleSubmitAddCars(e)}
          label="Submit"
        />
      </Dialog>

      <Dialog
        className="custom-dialog"
        visible={showEditDialog}
        onHide={() => {
          setShowEditDialog(false);
          clearVariables();
        }}
        header="Edit Car Details"
      >
        <div className="flex gap-3">
          <div className="flex flex-column">
            <label htmlFor="productID">
              <b>Product</b>
            </label>

            <InputText
              id="productID"
              type="text"
              value={productID}
              onChange={(e) => setProductID(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label htmlFor="productName">
              <b>Product Name</b>
            </label>
            <InputText
              id="productName"
              type="text"
              value={productName}
              onChange={(e) => setProductName(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label>
              <b>Description</b>
            </label>
            <InputText
              type="text"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>
        </div>

        <div className="flex gap-3">
          <div className="flex flex-column">
            <label>
              <b>Price</b>
            </label>
            <InputText
              type="text"
              value={price}
              onChange={(e) => setPrice(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label>
              <b>Selling Price</b>
            </label>
            <InputText
              type="text"
              value={sellingPrice}
              onChange={(e) => setSellingPrice(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label>
              <b>Generic Name</b>
            </label>
            <InputText
              type="text"
              value={genericName}
              onChange={(e) => setGenericName(e.target.value)}
            />
          </div>
        </div>

        <div className="flex gap-3">
          <div className="flex flex-column">
            <label>
              <b>Brand</b>
            </label>
            <InputText
              type="text"
              value={brand}
              onChange={(e) => setBrand(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label>
              <b>Model Number</b>
            </label>
            <InputText
              type="text"
              value={modelNumber}
              onChange={(e) => setModelNumber(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label>
              <b>Type</b>
            </label>
            <InputText
              type="text"
              value={type}
              onChange={(e) => setType(e.target.value)}
            />
          </div>
        </div>

        <div className="flex gap-3">
          <div className="flex flex-column">
            <label>
              <b>Age</b>
            </label>
            <InputText
              type="text"
              value={ageGroup}
              onChange={(e) => setAgeGroup(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label>
              <b>Maximum Weight</b>
            </label>
            <InputText
              type="text"
              value={maximumUserWeight}
              onChange={(e) => setMaximumUserWeight(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label>
              <b>Speed</b>
            </label>
            <InputText
              type="text"
              value={speed}
              onChange={(e) => setSpeed(e.target.value)}
            />
          </div>
        </div>

        <div className="flex gap-3">
          <div className="flex flex-column">
            <label>
              <b>Delivery Condition</b>
            </label>
            <InputText
              type="text"
              value={deliveryCondition}
              onChange={(e) => setDeliveryCondition(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label>
              <b>No Of Seats</b>
            </label>
            <InputText
              type="text"
              value={numberOfSeats}
              onChange={(e) => setNumberOfSeats(e.target.value)}
            />
          </div>
          {/* <div className="flex flex-column">
            <label>Battery Operated</label>
            <Dropdown
              // type="text"
              value={batteryOperated}
              options={yesNoOptions}
              onChange={(e) => setBatteryOperated(e.target.value)}
              className="w-full"
            />
          </div> */}
          <div className="flex flex-column w-full">
            <label>
              <b>Battery Operated</b>
            </label>
            <Dropdown
              value={batteryOperated}
              options={yesNoOptions}
              onChange={(e) => setBatteryOperated(e.target.value)}
              placeholder="Select"
              className="w-full"
            />
          </div>
        </div>

        <div className="flex gap-3">
          <div className="flex flex-column">
            <label>
              <b>No Of Batteries</b>
            </label>
            <InputText
              type="text"
              value={noOfBatteries}
              onChange={(e) => setNoOfBatteries(e.target.value)}
            />
          </div>
          {/* <div className="flex flex-column">
            <label>Rechargeable</label>
            <InputText
              type="text"
              value={rechargeable}
              onChange={(e) => setRechargeable(e.target.value)}
            />
          </div> */}
          <div className="flex flex-column w-full">
            <label>
              <b>Rechargeable</b>
            </label>
            <Dropdown
              value={rechargeable}
              options={yesNoOptions}
              onChange={(e) => setRechargeable(e.target.value)}
              placeholder="Select"
              className="w-full"
            />
          </div>
          <div className="flex flex-column">
            <label>
              <b>Battery Type</b>
            </label>
            <InputText
              type="text"
              value={batteryType}
              onChange={(e) => setBatteryType(e.target.value)}
            />
          </div>
        </div>

        <div className="flex gap-3">
          <div className="flex flex-column">
            <label>
              <b>Other Power Details</b>
            </label>
            <InputText
              type="text"
              value={otherPowerFeatures}
              onChange={(e) => setOtherPowerFeatures(e.target.value)}
            />
          </div>
          {/* <div className="flex flex-column">
            <label>Key Start</label>
            <InputText
              type="text"
              value={keyStart}
              onChange={(e) => setKeyStart(e.target.value)}
            />
          </div> */}
          <div className="flex flex-column w-full">
            <label>
              <b>Key Start</b>
            </label>
            <Dropdown
              value={keyStart}
              options={yesNoOptions}
              onChange={(e) => setKeyStart(e.target.value)}
              placeholder="Select"
              className="w-full"
            />
          </div>
          {/* <div className="flex flex-column">
            <label>Parental Remote</label>
            <InputText
              type="text"
              value={parentalRemote}
              onChange={(e) => setParentalRemote(e.target.value)}
            />
          </div> */}
          <div className="flex flex-column w-full">
            <label>
              <b>Parental Remote</b>
            </label>
            <Dropdown
              value={parentalRemote}
              options={yesNoOptions}
              onChange={(e) => setParentalRemote(e.target.value)}
              placeholder="Select"
              className="w-full"
            />
          </div>
        </div>

        <div className="flex gap-3">
          {/* <div className="flex flex-column">
            <label>Light</label>
            <InputText
              type="text"
              value={lights}
              onChange={(e) => setLights(e.target.value)}
            />
          </div> */}
          <div className="flex flex-column w-full">
            <label>
              <b>Light</b>
            </label>
            <Dropdown
              value={lights}
              options={yesNoOptions}
              onChange={(e) => setLights(e.target.value)}
              placeholder="Select"
              className="w-full"
            />
          </div>
          {/* <div className="flex flex-column">
            <label>Horn</label>
            <InputText
              type="text"
              value={horn}
              onChange={(e) => setHorn(e.target.value)}
            />
          </div> */}
          <div className="flex flex-column w-full">
            <label>
              <b>Horn</b>
            </label>
            <Dropdown
              value={horn}
              options={yesNoOptions}
              onChange={(e) => setHorn(e.target.value)}
              placeholder="Select"
              className="w-full"
            />
          </div>
          <div className="flex flex-column">
            <label>
              <b>Dimentions</b>
            </label>
            <InputText
              type="text"
              value={dimentions}
              onChange={(e) => setDimentions(e.target.value)}
            />
          </div>
        </div>

        <div className="flex gap-3">
          <div className="flex flex-column">
            <label>
              <b>Country</b>
            </label>
            <InputText
              type="text"
              value={countryOfOrigin}
              onChange={(e) => setCountryOfOrigin(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label>
              <b>Manufacter</b>
            </label>
            <InputText
              type="text"
              value={manufacturer}
              onChange={(e) => setManufacturer(e.target.value)}
            />
          </div>
          {/* <div className="flex flex-column">
            <label>Warrenty</label>
            <InputText
              type="text"
              value={warrenty}
              onChange={(e) => setWarrenty(e.target.value)}
            />
          </div> */}
          <div className="flex flex-column w-full">
            <label>
              <b>Warrenty</b>
            </label>
            <Dropdown
              value={warrenty}
              options={yesNoOptions}
              onChange={(e) => setWarrenty(e.target.value)}
              placeholder="Select"
              className="w-full"
            />
          </div>
        </div>

        <div className="flex gap-3">
          <div className="flex flex-column">
            <label>
              <b>Coverd In Warrenty</b>
            </label>
            <InputText
              type="text"
              value={coveredInWarranty}
              onChange={(e) => setCoveredInWarranty(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label>
              <b>Not Coverd In Warrenty</b>
            </label>
            <InputText
              type="text"
              value={notCoveredInWarranty}
              onChange={(e) => setNotCoveredInWarranty(e.target.value)}
            />
          </div>
          <div className="flex flex-column">
            <label>
              <b>Color</b>
            </label>
            <InputText
              type="text"
              value={color}
              onChange={(e) => setColor(e.target.value)}
            />
          </div>
        </div>

        <div className="flex gap-3">
          {/* <div className="flex flex-column">
            <label>Stock Availability</label>
            <InputText
              type="text"
              value={stockAvailability}
              onChange={(e) => setStockAvailability(e.target.value)}
            />
          </div> */}

          <div className="flex flex-column w-full">
            <label>
              <b>Stock Availability</b>
            </label>
            <Dropdown
              value={stockAvailability}
              options={yesNoOptions}
              onChange={(e) => setStockAvailability(e.target.value)}
              placeholder="Select"
              // className="w-full"
            />
          </div>

          <div className="flex flex-column">
            <label>
              <b>Quantity</b>
            </label>
            <InputText
              type="text"
              value={quantity}
              onChange={(e) => setQuantity(e.target.value)}
            />
          </div>
        </div>

        <Button
          type="submit"
          onClick={(e) => {
            handleSubmitUpdate(e);
          }}
          label="Submit"
        />
      </Dialog>

      <Card className="m-2">
        <Button
          security="info"
          label="Add"
          size="small"
          onClick={() => {
            setShowAddDialog(true);
            clearVariables();
          }}
        />
        <DataTable
          value={products}
          tableStyle={{ minWidth: "50rem" }}
          loading={loading}
          scrollable
          scrollHeight="400px"
          className="allDataTableThCenterCommon"
          resizableColumns
          size="small"
          rows={10}
          rowsPerPageOptions={[5, 10, 15, 25, 50]}
          paginator
          removableSort
          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
          currentPageReportTemplate="{first} to {last} of {totalRecords}"
          showGridlines
          emptyMessage="No Data found."
        >
          {/* <Column
            field="productID"
            header="Product ID"
            frozen
            body={(item) => (
              <span
                style={{
                  cursor: "pointer",
                  color: "blue",
                  textDecoration: "underline",
                }}
                onClick={() => {
                  navigate(`/carsById/${item.productID}`, {
                    state: { product: item },
                  });
                  sessionStorage.setItem("productId", item.productID);
                }}
              >
                {item.productID}
              </span>
            )}
          /> */}
          <Column
            field="productID"
            header="Product ID"
            frozen
            body={(item) => (
              <span
                style={{
                  cursor: "pointer",
                  color: "blue",
                  textDecoration: "underline",
                }}
                onClick={() => handleViewClick(item.productID)}
              >
                {item.productID}
              </span>
            )}
          />

          {/* <Column field="productName" header="Name"></Column> */}
          <Column
            field="productName"
            header="Name"
            body={(rowData) => (
              <span title={rowData.productName}>
                {rowData.productName.length > 50
                  ? rowData.productName.substring(0, 50) + "..."
                  : rowData.productName}
              </span>
            )}
          ></Column>
          {/* <Column field="description" header="Description"></Column> */}
          <Column
            field="description"
            header="Description"
            body={(rowData) => (
              <span title={rowData.description}>
                {rowData.description.length > 50
                  ? rowData.description.substring(0, 50) + "..."
                  : rowData.description}
              </span>
            )}
          ></Column>

          {/* <Column field="category" header="Category"></Column> */}
          <Column field="quantity" header="Quantity"></Column>
          {/* <Column header="Action" body={handleEditRowClick}></Column> */}
          <Column
            header="Action"
            body={(rowData) => (
              <Button
                label="Edit"
                icon="pi pi-pencil"
                onClick={() => handleEditRowClick(rowData)}
              />
            )}
          />
        </DataTable>
      </Card>
    </div>
  );
}

export default TabViewCars;
